/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCarePatient } from './MatrixCarePatient';
import {
    MatrixCarePatientFromJSON,
    MatrixCarePatientFromJSONTyped,
    MatrixCarePatientToJSON,
    MatrixCarePatientToJSONTyped,
} from './MatrixCarePatient';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatient201ResponseData
 */
export interface CreateMatrixCarePatient201ResponseData {
    /**
     * Indicates if a duplicate resident was detected in MatrixCare
     */
    isDuplicatePatientError?: boolean;
    /**
     * Indicates that a duplicate was found and SSN is required to proceed with document upload
     */
    requiresSsnForDuplicate?: boolean;
    /**
     * 
     */
    record?: MatrixCarePatient;
}

/**
 * Check if a given object implements the CreateMatrixCarePatient201ResponseData interface.
 */
export function instanceOfCreateMatrixCarePatient201ResponseData(value: object): value is CreateMatrixCarePatient201ResponseData {
    return true;
}

export function CreateMatrixCarePatient201ResponseDataFromJSON(json: any): CreateMatrixCarePatient201ResponseData {
    return CreateMatrixCarePatient201ResponseDataFromJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatient201ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'isDuplicatePatientError': json['isDuplicatePatientError'] == null ? undefined : json['isDuplicatePatientError'],
        'requiresSsnForDuplicate': json['requiresSsnForDuplicate'] == null ? undefined : json['requiresSsnForDuplicate'],
        'record': json['record'] == null ? undefined : MatrixCarePatientFromJSON(json['record']),
    };
}

export function CreateMatrixCarePatient201ResponseDataToJSON(json: any): CreateMatrixCarePatient201ResponseData {
    return CreateMatrixCarePatient201ResponseDataToJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseDataToJSONTyped(value?: CreateMatrixCarePatient201ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isDuplicatePatientError': value['isDuplicatePatientError'],
        'requiresSsnForDuplicate': value['requiresSsnForDuplicate'],
        'record': MatrixCarePatientToJSON(value['record']),
    };
}

